var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementHydro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.09 314.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4cc2f1;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_10",
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.62,280c-15.53.38-28.14-2.22-38.2-6.05A122.71,122.71,0,0,0,156.62,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.39,225v0a17.1,17.1,0,0,0,1.75,7.33,37.87,37.87,0,0,0,18.63,18.08h0a37.51,37.51,0,0,0,15.33,3.25c19.53,0,28.31-12.44,29.43-17.49-1.39,7.53-12.66,24-35.92,24A44.18,44.18,0,1,1,199.13,204c.09.26.16.53.23.81s.11.43.16.65a16.82,16.82,0,0,1,.3,2,0,0,0,0,1,0,0v.11a17,17,0,0,1-12.09,17.79,17.27,17.27,0,0,1-8.2.39,17.06,17.06,0,0,1-13.39-13.22,15.05,15.05,0,0,1-.25-1.52,15,15,0,0,0-14.71-11.89,15.62,15.62,0,0,0-2.29.17q-.75.12-1.47.3A26.08,26.08,0,0,0,127.39,225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.14,97.24c-.44.78-.87,1.57-1.28,2.37A15.9,15.9,0,0,1,49.14,97.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.13,159a16.28,16.28,0,0,1-8.8,14.47h0A16.31,16.31,0,1,1,67.13,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.11,212.7A11.94,11.94,0,0,1,78,223.64a11.76,11.76,0,0,1-4.48,1h-.3a11.93,11.93,0,0,1-2-23.7,11.4,11.4,0,0,1,2-.16A11.93,11.93,0,0,1,85.11,212.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.58,155.7c.71,68-55,124.29-123,124.29a122.71,122.71,0,0,1-38.2-6.05c-23.47-8.95-33-24.67-33.3-25.16a108.58,108.58,0,0,0,32.14,16c1.16.36,2.31.7,3.44,1h0a123.38,123.38,0,0,0,35.88,4.69c1.34,0,2.66,0,4-.08,23.68-.94,45.25-14.7,55.1-36.25A68.25,68.25,0,0,0,221.76,202c-1.91-36.23-32.38-64.85-68.66-64.65a68,68,0,0,0-17.63,2.4l-.28.08a17.07,17.07,0,0,1-4.14.51,16.81,16.81,0,0,1-7-32.12l.13,0,.18-.08.07,0,.33-.13.82-.31,0,0a86.07,86.07,0,0,1,88,144.61,98.16,98.16,0,0,0,41.25-80.83c-.41-53.38-44.07-97.08-97.45-97.54A98.16,98.16,0,0,0,76.71,114.9c-.34.46-.66.92-1,1.38A16.37,16.37,0,0,1,47.86,99.61c.41-.8.84-1.59,1.28-2.37A123,123,0,0,1,279.58,155.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.62,280c-15.53.38-28.14-2.22-38.2-6.05A122.71,122.71,0,0,0,156.62,280Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 314.09,
    height: 314.09
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementHydro);
export default __webpack_public_path__ + "static/media/Element_Hydro.dbcf75ab6927f7b73d17f4fb71f621ac.svg";
export { ForwardRef as ReactComponent };